import { produce } from "immer";
import { execute, initialState } from "../state/state";
import { machine_alphabet } from "../state/machine";
import { mealyExecuteStep, mealyInitExecutionState as mealyInitExecutionState } from "../mealy/mealyExecute";
import { initialAmpelSystemState } from "../mealyModels/AmpelSystem/ampelSystemState";
import { MealyModelType } from "../mealyModels/mealyModelType";
import { EditMode } from "../state/uiState";
import { initialGaragentorSystemState } from "../mealyModels/Garagentor/garagentorSystemState";
import { initialDoorSystemState } from "../mealyModels/DoorSystem/doorSystemState";
export function machine_newProject(state) {
    return initialState;
}
export function machine_setAlphabet(state, alphabet) {
    return produce(state, draftState => {
        if (draftState.machineState.machine.type === 'DEA') {
            draftState.machineState.machine.alphabet = alphabet;
            for (const transition of Object.values(draftState.machineState.machine.transitions)) {
                transition.chars = transition.chars.filter(char => alphabet.includes(char));
            }
        }
    });
}
export function machine_execute(state, input) {
    const executionResult = execute(state.machineState.machine, input);
    return produce(state, draftState => {
        draftState.machineState.executionState = executionResult;
        draftState.machineState.uiState.selection = {};
        draftState.uiState.editMode = EditMode.EXECUTION;
        draftState.uiState.execution.inputPosition = 0;
    });
}
export function machine_startExecution(state) {
    if (state.machineState.type === 'MachineStateMealy') {
        return Object.assign(Object.assign({}, state), { machineState: mealyMachine_startExecution(state.machineState) });
    }
    // TODO: exhaustive check
}
export function mealyMachine_startExecution(machineState) {
    return produce(machineState, draft => {
        draft.uiState.editMode = EditMode.EXECUTION;
        draft.uiState.selection = {};
        draft.executionState = mealyInitExecutionState(machineState.machine);
        if (draft.mealyModelType === MealyModelType.AMPELSYSTEM) {
            draft.ampelSystemState = initialAmpelSystemState;
        }
        else if (draft.mealyModelType === MealyModelType.GARAGENTOR) {
            draft.garagentorSystemState = initialGaragentorSystemState;
        }
        else if (draft.mealyModelType === MealyModelType.DOORSYSTEM) {
            draft.doorSystemState = initialDoorSystemState;
        }
    });
}
export function mealyMachine_Ampelsystem_pauseTimer(machineState) {
    return produce(machineState, draftMachineState => {
        draftMachineState.ampelSystemState.timer.state = 'paused';
    });
}
export function mealyMachine_Ampelsystem_resumeTimer(machineState, resumeTimestamp) {
    return produce(machineState, draftMachineState => {
        let timerDraft = draftMachineState.ampelSystemState.timer;
        timerDraft.state = 'running';
        timerDraft.lastResumeTimestamp = resumeTimestamp;
        timerDraft.lastResumeValue = timerDraft.value;
    });
}
export function mealyMachine_Ampelsystem_startTimer(machineState, startTimestamp, timerVaule) {
    return produce(machineState, draftMachineState => {
        draftMachineState.ampelSystemState.timer.state = 'running';
        draftMachineState.ampelSystemState.timer.value = timerVaule;
        draftMachineState.ampelSystemState.timer.lastResumeValue = timerVaule;
        draftMachineState.ampelSystemState.timer.lastResumeTimestamp = startTimestamp;
    });
}
export function mealyMachine_Ampelsystem_setTimer(machineState, isRunning, timerValue) {
    return produce(machineState, draftMachineState => {
        let timerDraft = draftMachineState.ampelSystemState.timer;
        timerDraft.value = timerValue;
    });
}
export function mealyMachine_Ampelsystem_stopTimer(machineState, timerValue) {
    return produce(machineState, draftMachineState => {
        let timerDraft = draftMachineState.ampelSystemState.timer;
        timerDraft.state = 'stopped';
        timerDraft.value = timerValue;
    });
}
export function mealyMachine_Garagentor_setPosition(machineState, position) {
    return produce(machineState, draftMachineState => {
        draftMachineState.garagentorSystemState.position = position;
    });
}
export const mealyMachine_Garagentor_setPosition2 = (position) => (machineState) => {
    return produce(machineState, draftMachineState => {
        draftMachineState.garagentorSystemState.position = position;
    });
};
export function mealyMachine_Garagentor_stopExecutionWithError(machineState, errorMessage) {
    return produce(machineState, draftMachineState => {
        draftMachineState.uiState.editMode = EditMode.NEUTRAL;
        draftMachineState.popUpMessage.isVisible = true;
        draftMachineState.popUpMessage.message = errorMessage;
    });
}
export function mealyMachine_Garagentor_startMovement(machineState, direction) {
    return produce(machineState, draftMachineState => {
        draftMachineState.garagentorSystemState.isMoving = true;
        draftMachineState.garagentorSystemState.direction = direction;
        draftMachineState.garagentorSystemState.moveStartTimestamp = performance.now();
        draftMachineState.garagentorSystemState.moveStartPosition = draftMachineState.garagentorSystemState.position;
    });
}
export function mealyMachine_Garagentor_ensureMovement(machineState, direction) {
    if (machineState.garagentorSystemState.isMoving && machineState.garagentorSystemState.direction === direction) {
        return machineState;
    }
    else {
        return produce(machineState, draftMachineState => {
            draftMachineState.garagentorSystemState.isMoving = true;
            draftMachineState.garagentorSystemState.direction = direction;
            draftMachineState.garagentorSystemState.moveStartTimestamp = performance.now();
            draftMachineState.garagentorSystemState.moveStartPosition = draftMachineState.garagentorSystemState.position;
        });
    }
}
export function mealyMachine_Garagentor_stopMovement(machineState) {
    return produce(machineState, draftMachineState => {
        draftMachineState.garagentorSystemState.isMoving = false;
    });
}
export function mealyMachine_executeSingleStep(machineState, input) {
    const [newExecutionState, stepHasBeenExecuted] = mealyExecuteStep(machineState.machine, machineState.executionState, input);
    if (stepHasBeenExecuted) {
        return [produce(machineState, draftMachineState => {
                draftMachineState.executionState = newExecutionState;
            }), stepHasBeenExecuted];
    }
    else {
        return [produce(machineState, draftMachineState => {
                draftMachineState.executionState = newExecutionState;
                draftMachineState.popUpMessage.isVisible = true;
                draftMachineState.popUpMessage.message = 'Das Eingabesymbol "' + input + '" kann nicht ausgeführt werden, da es im aktuellen Zustand keine passenden Übergang gibt.';
            }), stepHasBeenExecuted];
    }
}
export function machine_addBinState(state, missingTransitions) {
    return produce(state, draftState => {
        const machineDraft = draftState.machineState.machine;
        const binMachineStateId = draftState.machineState.machine.nextStateId.toString();
        machineDraft.machineStates[binMachineStateId] = {
            id: binMachineStateId,
            name: 'Bin',
            posx: 300,
            posy: 300,
            isStart: false,
            isFinal: false,
        };
        machineDraft.nextStateId++;
        for (let missingTransitionFromMachineState of missingTransitions) {
            const newTransitionId = machineDraft.nextTransitionId.toString();
            machineDraft.transitions[newTransitionId] = {
                type: 'TransitionDEA',
                id: newTransitionId,
                fromNodeId: missingTransitionFromMachineState.fromMachineStateId,
                toNodeId: binMachineStateId,
                controlPointOffset: 0,
                rotation: 0,
                chars: missingTransitionFromMachineState.chars,
            };
            machineDraft.nextTransitionId++;
        }
        const newTransitionId = machineDraft.nextTransitionId.toString();
        machineDraft.transitions[newTransitionId] = {
            type: 'TransitionDEA',
            id: newTransitionId,
            fromNodeId: binMachineStateId,
            toNodeId: binMachineStateId,
            controlPointOffset: 0,
            rotation: 0,
            chars: machine_alphabet(machineDraft),
        };
        machineDraft.nextTransitionId++;
    });
}
